import { Mapping, useCustomEventsQuery } from 'api/MappingsAPI';
import { useError } from 'react-use';

const aggregateFieldNames = (mappings: Mapping[]) => mappings.map(({ fieldName }) => fieldName);

export const useMappingCustomEvents = () => {
  const onError = useError();
  const { data = [], isLoading } = useCustomEventsQuery({ fetchLatest: true }, { onError });
  const customEvents = aggregateFieldNames(data);
  return { customEvents, isLoading };
};
